module.exports = __webpack_public_path__ + "static/media/avatRev.de88f5a0.png";